import InitialDataInteractor from "../../interactors/initial_data_interactor";

export default {
  name: 'initialDataInteractor',
  fn: InitialDataInteractor
}